import { TextField, Typography } from '@mui/material';
import { useField } from '@unform/core';
import React, { useEffect, useState } from 'react';
import { TVTextFieldProps } from '.';

export const VTextFieldCurrency: React.FC<TVTextFieldProps> = ({ name, ...rest }) => {
  const { fieldName, registerField, defaultValue, error } = useField(name);

  // defaultValue vem em centavos (ex: 1000 = R$ 10,00) ou como número decimal
  const initialDisplay = (() => {
    if (!defaultValue && defaultValue !== 0) return '';
    const num = Number(defaultValue);
    return num > 0 ? num.toFixed(2) : '';
  })();
  const [value, setValue] = useState(initialDisplay);

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => {
        if (!value) return undefined;
        // Remove tudo que não é dígito e converte para decimal
        const digits = value.replace(/[^0-9]/g, '');
        return digits ? parseFloat(digits) / 100 : 0;
      },
      setValue: (_, newValue) => {
        if (newValue === undefined || newValue === null) {
          setValue('');
        } else {
          const num = Number(newValue);
          setValue(num > 0 ? num.toFixed(2) : '');
        }
      },
      clearValue: () => setValue(''),
    });
  }, [registerField, fieldName, value]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const raw = event.target.value.replace(/[^0-9]/g, '');
    if (raw === '') {
      setValue('');
    } else {
      const numericValue = parseFloat(raw) / 100;
      setValue(numericValue.toFixed(2));
    }
    rest.onChange?.(event);
  };

  return (
    <TextField
      name={name}
      {...rest}
      fullWidth
      value={value}
      onChange={handleChange}
      placeholder='0,00'
      InputProps={{
        startAdornment: <Typography variant='body2' sx={{ mr: 0.5, color: 'text.secondary' }}>R$</Typography>,
      }}
      inputProps={{
        inputMode: 'decimal',
      }}
      error={!!error}
      helperText={error || ''}
      onKeyDown={(e) => { rest.onKeyDown?.(e); }}
    />
  );
};
